import React from 'react';
import c from 'classnames';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

type Direction = 'up' | 'down';

export interface WebformQuizThumbProps {
  direction: Direction;
  className?: string;
}

const WebformQuizThumb: React.FC<WebformQuizThumbProps> = (props) => {
  const { direction, className } = props;

  const classNames = c('WebformQuiz__Thumb', className, {
    [`WebformQuiz__Thumb--${String(direction)}`]: direction !== undefined,
  });

  return (
    <div className={classNames}>
      <Icon name="thumb" />
    </div>
  );
};

export default WebformQuizThumb;
